import React from "react";
import {
  InsurerCardWrapper,
  ProviderLogo,
  ProviderName,
} from "pages/Utilities/styles";

function InsurerCard({ insurer, isSelected, onClick }) {
  return (
    <InsurerCardWrapper
      key={insurer.service_provider_id}
      selected={isSelected}
      onClick={onClick}
    >
      <div>
        <ProviderLogo src={insurer.logo_url} alt={insurer.display_name} />
      </div>
      <footer>
        <ProviderName>{insurer.display_name}</ProviderName>
      </footer>
    </InsurerCardWrapper>
  );
}

export default InsurerCard;
